module.exports = __webpack_public_path__ + "static/electronics-880f10b384c788fd1496e99ee4249144.svg";